export enum PricingMessages {
    EDITED = "Edycja przebiegła pomyślnie",
    ADDED = "Pomyślnie dodano nowe ceny",
    PRICE_ALREDY_EXISTS = "Cena dla tego typu zamówienia już istnieje"
}